<template>
  <div class=" section_sectionWrapper">
    <div class="module-progress">
      <div class="title"></div>
      <div class="progress-cont">
        <div class="progress-box">
          <div class="cat-icon"></div>
          <div class="preview">
            <div class="preivew-cnt">
              <div class="preview-number">
                <img :src="require('../../assets/img/progressPage/num-' + item + '.png')" alt="" srcset=""
                  v-for="(item, index) in previewNumber" :key="index">
                <div class="font"></div>
              </div>
            </div>
          </div>
          <div class="page-progress">
            <div class="defaultPro progress-size" v-if="preview < 100000">
              <img src="../../assets/img/progressPage/default.png" alt="" srcset="">
            </div>
            <div v-else>
              <div class="progress-size" v-for="(value, fKey) in previewList" :key="fKey"
                :class="['item' + (fKey + 1), (preview >= value && ((fKey + 1) === previewList.length || preview < previewList[fKey + 1])) ? 'pimg-block' : 'pimg-none',]">
                <img :src="require('../../assets/img/progressPage/gift' + (fKey + 1) + '.png')" alt="" srcset="">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'app',
  props: ["isPreviewNumber"],

  data() {
    return {
      preview: 0,
      previewList: [100000, 300000, 500000, 700000, 1000000, 1500000], // 卡片
      previewNumber: ''
    }
  },
  created() {
    this.previewNumber = this.preview == 0 ? ['0', '0', '0', '0', '0', '0'] : this.preview.toString().split('')
  },
  watch: {
    // 监听到父组件传递过来的数据后，加工一下，
    // 存到data中去，然后在页面上使用
    isPreviewNumber(newVal, oldVal) {
     
      this.previewNumber = newVal == 0 ? ['0', '0', '0', '0', '0', '0'] : newVal.toString().split('')
    },

  },
  methods: {

  }
}
</script>
<style lang="scss" scoped>
.module-progress {
  position: relative;
  height: 100%;
  width: 100%;

  .pimg-block {
    display: block;
  }

  .pimg-none {
    display: none;
  }

  .title {
    width: 320px;
    height:105px;
    background-size: 100% 100%;
    position: absolute;
    top: 109px;
    left: 50%;
    transform: translateX(-50%);
    background-image: url("../../assets/img/progressPage/title.png");
  }

  .progress-cont {
    width: 1474px;
    height: 727px;
    background-size: 100% 100%;
    background-image: url("../../assets/img/progressPage/arrow-bg.png");
    position: absolute;
    left: 50%;
    transform: translate(-50%, -50%);
    top: 53%;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;

    .progress-box,
    .preivew-cnt {
      position: relative;
      width: 100%;
      height: 100%;

    }

    .cat-icon {
      width: 316px;
      height: 450px;
      background-size: 100% 100%;
      background-image: url("../../assets/img/progressPage/cat.png");
      position: absolute;
      bottom: 0;
      z-index: 1;

    }

    .preview {
      width: 725px;
      height: 77px;
      background-size: 100% 100%;
      background-image: url("../../assets/img/progressPage/num-bg.png");
      position: absolute;
      left: 200px;
      top: 114px;

      .preview-number {
        position: absolute;
        left: 396px;
        transform: translate(0, -50%);
        top: 45%;
        display: flex;
        align-items: end;
        gap: 6px;

        img {
          width: 18px;
          height: 32px;
          display: block;
        }
      }
    }

    .page-progress {
      // width: 1158px;
      // height: 530px;
      width: 1302px;
      height: 596px;
      position: absolute;
      right: 0;
      bottom: 20px;

      img {
        width: 100%;
        height: 100%;
        display: block;
      }
    }
  }
}

@media screen and (max-width: 1200px) {
  .module-progress {
    .title {
      top: 110px;

    }
    .progress-cont  {
      top: 50% !important;
    }
  }
}

@media screen and (min-width: 2560px) and (max-width: 3440px) {
  .module-progress {
    .title {
      width: 285px !important;
      height: 94px !important;

    }

    .progress-cont {
      width: 1180px !important;
      height: 582px !important;

      .cat-icon {
        width: 253px !important;
        height: 360px !important;
      }

      .preview {
        width: 580px !important;
        height: 62px !important;
        left: 160px !important;
        top: 88px !important;

        .preview-number {
          left: 320px !important;

        }
      }

      .page-progress {
        width: 1042px !important;
        height: 480px !important;
        bottom: 16px !important;

      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/publicComponents/progressPage.vue